module.exports = __webpack_public_path__ + "static/o_nama-632f08d7d0caeaa761ac9b9cc7b0fea2.svg";